"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CourierBox = void 0;
var _culture = require("@ori/culture");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _models = require("../../models");
var _ShippingOffer = require("../DeliveryBox/ShippingOffer");
var _ShippingOfferTooltip = require("../DeliveryBox/ShippingOfferTooltip");
var _HintMessage = require("../HintMessage");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const CourierBox = (param)=>{
    let { courier, isActive, isBoundCourier, isDisabled, hintMessages = [], onShippingOfferBannerClick } = param;
    const { getTestIdProps } = (0, _testidGenerator.default)();
    const { deliveryFee, estimatedDelivery, image, isShippingJoker, name, originalDeliveryFee } = courier;
    const isShippingOfferBanner = isShippingJoker && isActive;
    const isShippingOfferIcon = isShippingJoker && !isActive;
    const DeliveryFeeCompontent = /*#__PURE__*/ (0, _jsxRuntime.jsx)(_culture.FormatCurrency, {
        children: deliveryFee
    });
    const DeliveryFeeActiveCompontent = /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
        children: DeliveryFeeCompontent
    });
    const ownerState = {
        isDisabled
    };
    const rootTestiId = isBoundCourier ? _models.TestId.BoundCourierBox : _models.TestId.CourierBox;
    const courierInfoTestId = isDisabled ? _models.TestId.CourierInfoDisabled : _models.TestId.CourierInfo;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.CourierBoxRoot, {
        ...getTestIdProps(rootTestiId),
        ownerState: {
            isBoundCourier
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.CourierBoxWrapper, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.CourierInfo, {
                    ...getTestIdProps(courierInfoTestId),
                    ownerState: {
                        isBoundCourier
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.CourierDescription, {
                            children: [
                                image ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Image, {
                                    src: image.src,
                                    alt: image.alt,
                                    ...getTestIdProps(_models.TestId.CourierImage),
                                    ownerState: ownerState
                                }) : null,
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("figcaption", {
                                    children: name
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.DeliveryInfo, {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.DeliveryFee, {
                                    ...getTestIdProps(_models.TestId.CourierFee),
                                    ownerState: ownerState,
                                    children: [
                                        isShippingOfferIcon ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ShippingOfferTooltip.ShippingOfferTooltip, {
                                            isDisabled: isDisabled
                                        }) : null,
                                        isActive ? DeliveryFeeActiveCompontent : DeliveryFeeCompontent
                                    ]
                                }),
                                Number(originalDeliveryFee) > 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.OriginalShippingFee, {
                                    variant: "caption",
                                    ...getTestIdProps(_models.TestId.OriginalDeliveryFee),
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_culture.FormatCurrency, {
                                        children: Number(originalDeliveryFee)
                                    })
                                }) : null,
                                estimatedDelivery ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.EstimatedDelivery, {
                                    ownerState: ownerState,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.TruckIcon, {}),
                                        estimatedDelivery
                                    ]
                                }) : null
                            ]
                        })
                    ]
                })
            }),
            isActive ? hintMessages.map((message)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_HintMessage.HintMessage, {
                    message: message
                }, message)) : null,
            isShippingOfferBanner ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ShippingOffer.ShippingOffer, {
                onClick: onShippingOfferBannerClick
            }) : null
        ]
    });
};
exports.CourierBox = CourierBox;
